import { Component } from "react";

export default class FiltersByStatusRow extends Component {
  render() {
    return (
      <div className="row">
        <div className="btn-group-g ">
          <button
            type="button"
            className="btn label-request g"
            onClick={() => this.props.filterByStatus(0)}
          >
            Request
          </button>
          <button
            type="button"
            className=" btn label-check g"
            onClick={() => this.props.filterByStatus(1)}
          >
            Check
          </button>
          <button
            type="button"
            className="btn label-verified g"
            onClick={() => this.props.filterByStatus(2)}
          >
            Verify
          </button>
          <button
            type="button"
            className="btn label-pending-for-payment g"
            onClick={() => this.props.filterByStatus(22)}
          >
            Pending For Payment
          </button>

          <button
            type="button"
            className="btn label-reject g"
            onClick={() => this.props.filterByStatus(4)}
          >
            Reject
          </button>
        </div>
      </div>
    );
  }
}
